import { fromJS } from 'immutable'

import { CHANGE_WORKSHOP, CHANGE_EDITTING, NEW_WORKSHOP } from './constants'

import { tabChanged } from 'scenes/VehicleDetail/utils'

import { LOCATION_CHANGE } from 'react-router-redux'

export const initialState = fromJS({
  workshop: {},
  editting: false,
  newWorkshopStatus: false
})

export default function reducer(state = initialState, action) {
  switch(action.type) {
    case CHANGE_WORKSHOP:
      return state.set('workshop', action.workshop)
    case CHANGE_EDITTING:
      return state.set('editting', action.editting)
    case NEW_WORKSHOP:
      return state.set('newWorkshopStatus', action.newWorkshopStatus)
    case LOCATION_CHANGE:
      return tabChanged(action.payload, 'siniestro', state, initialState)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/ClaimData/Workshop/reducer.js